import request from './http';

// 新增用户信息
export const addUserMangeInfo = data => {
    return request({
        url: '/auth/user/addUserInfo',
        method: 'post',
        data
    })
}

// 修改用户信息
export const updateUserInfo = data => {
    return request({
        url: '/auth/user/modifyUserInfo',
        method: 'post',
        data
    })
}

// 删除用户信息
export const deleteUserMange = data => {
    return request({
        url: '/auth/user/deleteUserInfo?userId='+data,
        method: 'get',
    })
}

// 重置密码
export const resetUserPassword = data => {
    return request({
        url: '/auth/user/resetPassWord?passWord='+data.passWord+"&userId="+data.userId,
        method: 'get',
    })
}

// 分页查询用户信息
export const getUserData = data => {
    return request({
        url: '/auth/user/pageFindUserInfo',
        method: 'post',
        data
    })
}

// 更新用户状态
export const updateUserStatus = data => {
    return request({
        url: '/auth/user/updateUserInfo?companyId='+data.companyId+"&userId="+data.userId+"&userStatus="+data.userStatus,
        method: 'get'
    })
}

// 根据系统id查找岗位信息
export const getPostInfo = data => {
    return request({
        url: '/auth/user/findPositionInfo?companyId='+data.companyId+"&userCode="+data.userCode,
        method: 'get'
    })
}

// 根据系统id查询部门信息
export const getDepartInfo = data => {
    return request({
        url: '/auth/user/findDepartInfo?companyId='+data.companyId+"&userCode="+data.userCode,
        method: 'get'
    })
}

// 查询角色信息
export const getRoleInfo = data => {
    return request({
        url: '/auth/user/pageFindRoleInfo',
        method: 'post',
        data
    })
}

// 给用户分配角色
export const assignmentRole = data => {
    return request({
        url: '/auth/user/allocationRole?companyId='+data.companyId+"&userCode="+data.userCode+"&roleIds="+data.roleIds,
        method: 'get'
    })
}

// 用户离职更新客户数据
export const updateHandOverStatus = data => {
    return request({
        url: '/auth/user/updateCustomerHandOverStatus?userCode='+data.userCode+"&userId="+data.userId+"&workStatus="+data.workingStatus,
        method: 'get',
    })
}

// 用户关联系统部门岗位信息
export const userRelationSystem = data => {
    return request({
        url: '/auth/user/addUserRelationSystemInfo',
        method: 'post',
        data
    })
}

// 根据系统ID(可多个)查询岗位信息
export const findByPostItem = data => {
    return request({
        url: '/auth/user/findByPositionItemInfo?companyIds='+data.companyIds+"&userCode="+data.userCode,
        method: 'get',
    })
}

// 根据系统ID查找部门信息
export const findDepartItemInfo = data => {
    return request({
        url: '/auth/user/findByDepartItemInfo?companyIds='+data.companyIds+"&userCode="+data.userCode,
        method: 'get',
        data
    })
}

// 根据用户ID查询用户信息
export const getUserInfoForCompanyId = data => {
    return request({
        method: 'get',
        url: '/auth/diyPermission/getUserInfoAndCompanyByUserId?userId='+data,
    })
}

// 查询所有的系统用户角色信息
export const getAllCompanyList = data => {
    return request({
        method: 'get',
        url: '/auth/access/findSystemItemInfo?roleName=' + data
    })
}

// 根据系统编号查询该系统所有的角色
export const getAllRoleForCompany = data => {
    return request({
        method: 'get',
        url: '/auth/diyPermission/queryRoleAndCompanyId?companyId='+data,
    })
}

// 修改用户角色
export const changeUserRole = data => {
    return request({
        method: 'get',
        url: '/auth/diyPermission/updateUserRole?userId='+data.userId+"&roleArray="+data.roleArray
    })
}

// 查询所有用户列表
export const findUserInfo = data => {
    return request({
        method: 'get',
        url: '/auth/copy/findUserInfo'
    })
}

// 复制权限
export const copyJurisdiction = data => {
    return request({
        method: 'get',
        url: '/auth/copy/copyAccessInfo?userCode='+data.userCode+"&userCodes="+data.userCodes
    })
}

// 检查用户是否存在
export const checkUserIsHas = data => {
    return request({
        method: 'get',
        url: '/auth/user/checkUserName?flag=true&userName='+data
    })
}

